import { useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Button,
  Divider,
  Autocomplete,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const webApplicationsOptions = [
  { name: "morProm", label: "หมอพร้อม" },
  { name: "LearnBuddy", label: "สอน.บัดดี้" },
  { name: "his", label: "HIS" },
  { name: "other", label: "อื่นๆ" },
];

const provinceOptions = [
  { label: "กาฬสินธุ์", value: "กาฬสินธุ์" },
  { label: "ขอนแก่น", value: "ขอนแก่น" },
];

const districtOptions = [
  { label: "ยางตลาด", value: "ยางตลาด" },
  { label: "เมือง", value: "เมือง" },
];

const subdistrictOptions = [
  { label: "หัวนาคำ", value: "หัวนาคำ" },
  { label: "ยางตลาด", value: "ยางตลาด" },
];

const titleOptions = [
  { label: "นาย", value: "นาย" },
  { label: "นาง", value: "นาง" },
  { label: "นางสาว", value: "นางสาว" },
];


interface FormData {
  title: string;
  firstName: string;
  lastName: string;
  idCard: string;
  businessLicense: string;
  address: string;
  building: string;
  alley: string;
  road: string;
  province: string;
  district: string;
  subdistrict: string;
  postalCode: string;
  postalCodeElectronic: string;
  phone: string;
  webApplications: string;
}

const defaultForm: FormData = {
  title: "",
  firstName: "",
  lastName: "",
  idCard: "",
  businessLicense: "",
  address: "",
  building: "",
  alley: "",
  road: "",
  province: "",
  district: "",
  subdistrict: "",
  postalCode: "",
  postalCodeElectronic: "",
  phone: "",
  webApplications: "",
};

const PersonSign = () => {
  const [forms, setForms] = useState<FormData[]>([defaultForm]);
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  const handleFormChange = (index: number, e: any) => {
    const { name, value } = e.target;
    setForms((prev) =>
      prev.map((form, i) => (i === index ? { ...form, [name]: value } : form))
    );
    setErrors((prev) => ({ ...prev, [name]: value === "" }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
      setForms((prev) => prev.map((form) => ({...form,webApplications: checked ? name : "",
    })));
  };

  const handleAutocompleteChange = (
    index: number,
    name: string,
    value: any
  ) => {
    setForms((prev) =>
      prev.map((form, i) =>
        i === index ? { ...form, [name]: value ? value.value : "" } : form
      )
    );
  };

  const handleAddForm = () => {
    if (forms.length< 4){
    setForms((prev) => [...prev, { ...defaultForm }]);
    }
  };

  return (
    <form>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        {/* <Grid item xs={12} md={3} sx={{ alignSelf: "center" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Web Application ที่ใช้
          </Typography>
        </Grid> */}
        {/* <Grid item xs={12} md={9}>
          <Grid container spacing={2} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
          {webApplicationsOptions.map((app) => (
              <Grid item key={app.name}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={forms[0].webApplications === app.name}
                      onChange={handleCheckboxChange}
                      name={app.name}
                    />
                  }
                  label={app.label}
                />
              </Grid>
            ))}
          </Grid>
        </Grid> */}
      </Grid>
      <Grid container sx={{ mt: 3 }} alignItems="center">
        <Grid item xs={12}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
            }}
          >
            ผู้ประกอบวิชาชีพร่วม (โปรดระบุถ้ามี)
          </Typography>
        </Grid>
      </Grid>

      {forms.map((form, index) => (
        <div key={index}>
          <Grid container sx={{ mt: 3 }} alignItems="center">
            <Grid item xs={12} md={2}>
              <Typography
                sx={{
                  bgcolor: "#616161",
                  color: "white",
                  borderRadius: "5px",
                  textAlign: "center",
                  fontSize: "14px",
                  width: "140px",
                  padding: "4px 6px",
                }}
              >
                บุคคลที่ {index + 1}
              </Typography>
            </Grid>
            <Grid item xs={12} md={10} sx={{ mt: { xs: 2, md: 0 } }}>
              <Divider />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
            <Grid item xs={12} sm={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={titleOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    titleOptions.find(
                      (option) => option.value === form.title
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "title", value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="คำนำหน้าชื่อ"
                      placeholder="เลือกคำนำหน้าชื่อ"
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                label={
                  <span>
                    ชื่อ <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="firstName"
                placeholder="กรุณากรอกชื่อ"
                value={form.firstName}
                onChange={(e) => handleFormChange(index, e)}
                error={errors.firstName}
                helperText={errors.firstName ? "กรุณากรอกชื่อ" : ""}
              />
            </Grid>

            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                label={
                  <span>
                    นามสกุล <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="lastName"
                placeholder="กรุณากรอกนามสกุล"
                value={form.lastName}
                onChange={(e) => handleFormChange(index, e)}
                error={errors.lastName}
                helperText={errors.lastName ? "กรุณากรอกนามสกุล" : ""}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="เลขประจำตัวประชาชน"
                name="idCard"
                placeholder="กรุณากรอกเลขประจำตัวประชาชน"
                value={form.idCard}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="เลขที่ใบอนุญาตประกอบวิชาชีพ"
                name="businessLicense"
                placeholder="กรุณากรอกเลขที่ใบอนุญาต"
                value={form.businessLicense}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="ที่อยู่"
                name="address"
                placeholder="กรุณากรอกที่อยู่"
                value={form.address}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="หมู่ / อาคาร"
                name="building"
                placeholder="กรุณากรอกหมู่ / อาคาร"
                value={form.building}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="ตรอก / ซอย"
                name="alley"
                placeholder="กรุณากรอกตรอก / ซอย"
                value={form.alley}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="ถนน"
                name="road"
                placeholder="กรุณากรอกถนน"
                value={form.road}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={3}>
              <FormControl sx={{ minWidth: "100%" }} size="small">
                <Autocomplete
                  options={provinceOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    provinceOptions.find(
                      (option) => option.value === form.province
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "province", value)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="จังหวัด" />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={3}>
              <FormControl sx={{ minWidth: "100%" }} size="small">
                <Autocomplete
                  options={districtOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    districtOptions.find(
                      (option) => option.value === form.district
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "district", value)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="อำเภอ" />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={3}>
              <FormControl sx={{ minWidth: "100%" }} size="small">
                <Autocomplete
                  options={subdistrictOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    subdistrictOptions.find(
                      (option) => option.value === form.subdistrict
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "subdistrict", value)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="ตำบล / แขวง" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="รหัสไปรษณีย์"
                name="postalCode"
                placeholder="กรุณากรอกรหัสไปรษณีย์"
                value={form.postalCode}
                onChange={(e) => handleFormChange(index, e)}
              />
            </Grid>
          </Grid>
        </div>
      ))}

      <Grid item xs={12} sx={{ display: "flex", alignItems: "center", mt: 5 }}>
        <Divider sx={{ flex: 1, mr: 2 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddForm}
          sx={{ width: "144px" }}
          startIcon={<AddIcon />}
          disabled={forms.length>=4}
        >
          เพิ่มรายการ
        </Button>
        <Divider sx={{ flex: 1, ml: 2 }} />
      </Grid>
      <Grid container sx={{ mt: 7 }}>
        <Grid item xs={12}>
          <Typography variant="body1">
            *หมายเหตุ : หน่วยบริการฯ สามารถสมัครเข้าร่วมตามนโยบาย “๓๐
            บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว”
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            ผ่านการสมัครโดยตรงกับสำนักงานสาธารณสุขจังหวัด เท่านั้น
            เนื่องจากต้องมีการตรวจสอบเอกสารประกอบการสมัคร
          </Typography>
        </Grid>
      </Grid>
    </form>
  );
};

export default PersonSign;
